import React, { useEffect, useState } from "react";
import Input from "../../templates/Input";
import { useDispatch, useSelector } from "react-redux";
import { clearBlogError, writeBlog } from "../../store/blogSlice";
import { clearJobError } from "../../store/jobSlice";
import { setPopup } from "../../store/popupSlice";

function WriteBlog() {
  const errorFromStore = useSelector((state) => state.blog.error);
  const loading = useSelector((state) => state.blog.loading);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [error, setError] = useState("");

  const inputFields = [
    { id: "title", label: "Title", required: true, placeholder: "Enter Title" },

    {
      id: "preview",
      label: "Preview",

      type: "rich-text",
    },
    {
      id: "description",
      label: "Job Description",
      placeholder: "Enter Description",
      type: "rich-text",
    },
  ];

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    setError("");
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    dispatch(clearBlogError());
  }, [dispatch]);

  const postBlog = async () => {
    const payload = { ...formData };
    const result = await dispatch(writeBlog(payload));

    if (result.payload?.success) {
      setFormData({});
      setError("");
      dispatch(clearJobError());

      dispatch(
        setPopup({
          message: `Blog "${result.payload.data.Title}" posted successfully!`,
          type: "success",
        })
      );
    } else {
      dispatch(
        setPopup({
          message: result.payload?.message || "Error writing blog",
          type: "error",
        })
      );
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-indigo-100 to-purple-100 flex items-center justify-center px-4 py-12 mt-[9vh]">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl p-10 border-t-4 border-purple-500">
        <h2 className="text-3xl font-extrabold text-center text-purple-700 mb-8">
          Write A Blog
        </h2>

        {(error || errorFromStore) && (
          <div className="bg-red-100 text-red-700 p-3 mb-6 rounded-lg shadow-sm text-center">
            {error || errorFromStore}
          </div>
        )}

        <div className="space-y-6">
          <Input
            fields={inputFields}
            onChange={handleChange}
            formData={formData}
          />
          <button
            type="button"
            disabled={loading}
            onClick={postBlog}
            className="w-full py-3 bg-purple-600 text-white font-semibold rounded-lg shadow hover:bg-purple-700 transition duration-300"
          >
            {loading ? "Posting Blog..." : "Post Blog"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WriteBlog;
